"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_CHAINID = exports.FALLBACK_DECIMALS = void 0;
exports.FALLBACK_DECIMALS = 18;
exports.FALLBACK_CHAINID = 42161;
//# sourceMappingURL=fallbacks.js.map